<div class="container" fxLayout="column" fxLayoutAlign="center center" fxLayoutGap="20px">
  <div fxLayout="row">
    <mat-icon>lock</mat-icon>
  </div>
  <span>{{ 'MAIN.NO_PERMISSIONS.EXPLANATION' | translate }}</span>
</div>
